import { Component, computed, inject, OnDestroy, OnInit, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CountDownPipe } from '@app/pipes/countdown/countdown-pipe';
import { AppStore } from '@app/stores/app/app.store';
import { IDynamicActions } from '@app/types/dynamic-actions';
import { IModalFormData } from '@app/types/modal-form-data';
import { FormDialogWrapperComponent } from '../form-dialog-wrapper/form-dialog-wrapper.component';
import { DataTestIdPipe } from '@app/pipes/data-test-id/data-test-id-pipe';
import { environment } from '@env/environment';
import { interval, Subscription, take } from 'rxjs';

@Component({
    selector: 'app-countdown',
    imports: [CountDownPipe, FormDialogWrapperComponent, DataTestIdPipe],
    templateUrl: './countdown.component.html',
    styleUrls: ['./countdown.component.scss'],
})
export class CountdownComponent implements OnInit, OnDestroy {
    readonly data = inject<IModalFormData>(MAT_DIALOG_DATA);
    readonly dialogRef = inject(MatDialogRef);
    countDownValue = signal<number>(environment.countDownWarningTimeOut);
    message = computed(() => {
        return this.data.data as string;
    });
    private appStore = inject(AppStore);
    translate = this.appStore.i18n;
    formDialogActions = computed<IDynamicActions[]>(() => {
        const { SignOut, StaySignedIn } = this.translate();
        return [
            {
                type: 'basic',
                text: SignOut,
                class: '',
                testId: 'cancel',
                onClick: this.onCancel.bind(this),
            },
            {
                type: 'flat',
                text: StaySignedIn,
                class: '',
                testId: 'submit',
                onClick: this.onSubmit.bind(this),
            },
        ];
    });
    subs$ = new Subscription();
    ngOnInit(): void {
        const timerInterval$ = interval(1000);

        const takeCountDownWarningTimeOut$ = timerInterval$.pipe(
            take(environment.countDownWarningTimeOut),
        );
        this.subs$.add(
            takeCountDownWarningTimeOut$.subscribe((value) => {
                const ctr = value + 1; // Start from 1
                const countdownValue = environment.countDownWarningTimeOut - ctr;
                this.countDownValue.set(countdownValue);
                if (countdownValue <= 0) {
                    this.dialogRef.close(false);
                }
            }),
        );
    }

    ngOnDestroy(): void {
        this.subs$.unsubscribe();
    }

    onCancel(e: Event) {
        e.preventDefault();
        this.dialogRef.close(false);
    }
    onSubmit(e: Event) {
        e.preventDefault();
        this.dialogRef.close(true);
    }
}
